module.exports = __webpack_public_path__ + "static/water_nubian4-2ce6a46fae986c9b3644f661dc0b90e8.jpg";